<template>
  <v-container>
    <v-row>
      <v-col v-for="post in posts" :key="post.id" cols="12" md="6" sm="12">
        <v-card
          v-if="post.type == 'blog'"
          class="mx-auto"
          elevation="0"
          :href="post.url"
          target="blank"
        >
          <v-img class="white--text align-end" height="200px" :src="post.src">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-card-subtitle class="pb-0">
            <v-btn href="#" text small color="primary" class="px-0"
              >{{ post.author }}
            </v-btn>
            <v-btn text small disabled class="px-0">{{
              post.created_at
            }}</v-btn>
          </v-card-subtitle>
          <v-card-text
            class="title font-weight-bold mt-3 pb-0 text--primary"
            style="line-height: 1.8rem"
          >
            {{ post.title }}
          </v-card-text>
          <v-card-text class="text--primary">
            {{ post.description }}
            <v-btn href="#" small text color="primary">more</v-btn>
          </v-card-text>

          <v-card-actions>
            <v-btn icon color="yellow darken-1"
              ><v-icon>mdi-comment</v-icon></v-btn
            >
            <span class="text--disabled">15</span>
            <v-spacer></v-spacer>
            <v-btn icon color="orange"> <v-icon>mdi-heart</v-icon> </v-btn
            ><span class="text--disabled mr-2">45K</span>
            <v-btn icon color="primary">
              <v-icon>mdi-share-variant</v-icon> </v-btn
            ><span class="text--disabled">25K</span>
            <span class="mr-4"></span>
          </v-card-actions>
        </v-card>
        <v-card
          v-else
          class="mx-auto"
          elevation="0"
          :href="post.url"
          target="blank"
        >
          <iframe
            height="350"
            width="100%"
            :src="post.src"
            title="YouTube video player"
            framebpackage="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

          <v-card-text class="text--primary">
            {{ post.title }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- <div class="text-center">
      <div class="text-center">
        <v-container
          >2016-2025 <a href="https://pexcode.com" target="blank">pexcode</a>
        </v-container>
      </div>
    </div> -->
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      posts: [
      {
          id: 7,
          color: 'blue',
          type: 'blog',
          icon: 'mdi-post',
          title: 'Big Business and multi shipping center ',
          src: 'https://files.pexcode.com/blog-files/bigB.png',
          url:
            'https://quickdeliverysystem.com/blog/big-business-and-multi-shipping-center/',
          author: 'pexcode / Mussab Muhaimeed',
          created_at: 'February 2, 2025',
          description:
            'Multi-Shipping Center Management System – The Optimal Solution for Organizing Shipping and Receiving Operations.',
        },
        {
          id: 8,
          color: 'blue',
          type: 'blog',
          icon: 'mdi-post',
          title: 'Small Business and one shipping center',
          src:
            'https://files.pexcode.com/blog-files/small%20B%20one%20branch.png',
          url:
            'https://quickdeliverysystem.com/blog/small-business-only-one-shipping-center/',
          author: 'pexcode / Mussab Muhaimeed',
          created_at: 'February 1, 2025',
          description:
            'The delivery company is a small startup operating with a single branch.',
        },
        {
          id: 6,
          color: "blue",
          type: "blog",
          icon: "mdi-archive-eye-outline",
          title: " Trust QDS / Trust client ",
          src: "https://files.pexcode.com/blog-files/qs1.PNG",
          url: "https://quickdeliverysystem.com/blog/trust-qds-trust-client-for-business/",
          author: "pexcode / Mussab Muhaimeed",
          created_at: "Jan 12, 2025",
          description: "Trust QDS / Trust client for business.",
        },
        {
          id: 9,
          color: "blue",
          type: "blog",
          icon: "mdi-code-braces-box",
          title: " qds - sdk ",
          src: "https://files.pexcode.com/blog-files/Artboard%201How%20to%20use%20API%20Quick%20delivery%20system%20v.1.0.jpg",
          url: "https://www.npmjs.com/package/@pexcode/qds-sdk",
          author: "pexcode / Mussab Muhaimeed",
          created_at: "December 22, 2024",
          description:
            "This is a library published under an pexcode to help users and developers to use quickdeliverysystem api.",
        },
        {
          id: 5,
          color: "blue",
          type: "blog",
          icon: "mdi-printer",
          title: "qds - print - sdk",
          src: "https://files.pexcode.com/blog-files/Artboard%201How%20to%20use%20API%20Quick%20delivery%20system%20v.1.0.jpg",
          url: "https://www.npmjs.com/package/@pexcode/qds-print-sdk",
          author: "pexcode / Mussab Muhaimeed",
          created_at: "December 22, 2024",
          description:
            "This is a library published under an pexcode to help users and developers to use quickdeliverysystem printing.",
        },

        {
          id: 1,
          type: "blog",
          url: "https://quickdeliverysystem.com/blog/how-use-api-quick-delivery-system-v-1-0/",
          src: "https://files.pexcode.com/blog-files/qs1.PNG",
          created_at: "Marz 13, 2024",
          title: "How to use API Quick delivery system v.1.0",
          description: `use API Quick delivery system to have a better handle on your business  ...`,
          author: "Mussab Muhaimeed",
        },
        {
          id: 4,
          type: "youtube",
          url: "https://www.youtube.com/embed/T8LxGBrVaz8?si=lpZ2EFZFGCUAJIW8",
          src: "https://www.youtube.com/embed/T8LxGBrVaz8?si=lpZ2EFZFGCUAJIW8",
          created_at: "Marz 13, 2024",
          title: "How create new company account/register",
          description: `use API Quick delivery system to have a better handle on your business  ...`,
          author: "Mussab Muhaimeed",
        },
        {
          id: 2,
          type: "blog",
          url: "https://quickdeliverysystem.com/blog/how-can-i-get-api-key-token-for-quick-delivery-services-quick-delivery-system/",
          src: "https://files.pexcode.com/blog-files/qs1.PNG",
          created_at: "March 16, 2024",
          title: "How To Get Quick Delivery Services API key (token) ",
          description: `a key to use quick delivery system API – also called a Token- is needed because ...`,
          author: "Mussab Muhaimeed",
        },
        {
          id: 3,
          type: "blog",
          url: "https://quickdeliverysystem.com/blog/quick-delivery-system-platform-services/",
          src: "https://files.pexcode.com/blog-files/qs1.PNG",
          created_at: "October 4, 2022",
          title: "Quick Services Guide for Delivery Companies Management",
          description: `It can be considered the most important part of our list of services for delivery companies ... `,
          author: "Abd alkarim nou",
        },
      ],
    };
  },
};
</script>
